export default {"src":"/_next/static/media/thief_24.6053d608.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};